import { queryClient } from "@/queryClient";
import { useMutation } from "@tanstack/react-query";
import { setNotificationReadStatus } from "@/modules/notification-center/api";

export const useMarkSingleNotification = () => {
  const { mutate: markSingleReadOrUnread, isPending } = useMutation({
    mutationFn: ({ id, read }: { id: string; read: boolean }) =>
      setNotificationReadStatus(id, read),
    onSuccess: (_data) => {
      queryClient.invalidateQueries({ queryKey: ["my-notifications"] });
    },
  });

  return { markSingleReadOrUnread, isPending };
};
